import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
import "./css/AvailabilityBar.css";

const AvailabilityBar = () => {

  const navigate = useNavigate();

  const today = new Date().toISOString().split("T")[0];

  // MODALS
  const [show, setShow] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const initialFormData = {
    arrival: "",
    departure: "",
    adults: 1,
    children: 0,
  };

  const [formData, setFormData] = useState(initialFormData);

  const [selectedRoom, setSelectedRoom] = useState(null);

  const [userData, setUserData] = useState({
    name: "",
    email: "",
  });

  const rooms = [
    { name: "Standard Room", price: "$100 / night" },
    { name: "Deluxe Room", price: "$120 / night" },
    { name: "Executive Room", price: "$150 / night" },
    { name: "VIP Room", price: "$180 / night" },
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleUserChange = (e) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };

  const increaseCount = (field) => {
    setFormData({
      ...formData,
      [field]: formData[field] + 1,
    });
  };

  const decreaseCount = (field) => {
    if (formData[field] > 1) {
      setFormData({
        ...formData,
        [field]: formData[field] - 1,
      });
    }
  };

  const decreaseCountchildren = (field) => {
    if (formData[field] > 0) {
      setFormData({
        ...formData,
        [field]: formData[field] - 1,
      });
    }
  };

  // OPEN FIRST MODAL
  const handleCheck = () => {
    if (!formData.arrival || !formData.departure) {
      alert("Please select arrival and departure dates");
      return;
    }
    setShow(true);
  };

  // CLOSE ALL
  const handleClose = () => {
    setShow(false);
    setShowUserModal(false);
    setFormData(initialFormData);
    setSelectedRoom(null);
    setUserData({ name: "", email: "" });
  };

  const handleRoomsPage = () => {
    navigate("/rooms");
  };

  // STEP 1 → GO TO USER MODAL
  const handleNext = () => {
    if (!selectedRoom) {
      alert("Please select a room first");
      return;
    }

    setShow(false);
    setShowUserModal(true);
  };

  // FINAL BOOKING EMAIL
  const handleBooking = () => {

    if (!userData.name || !userData.email) {
      alert("Please enter name and email");
      return;
    }

    setLoading(true);

    const templateParams = {
      name: userData.name,
      email: userData.email,
      arrival: formData.arrival,
      departure: formData.departure,
      adults: formData.adults,
      children: formData.children,
      room_name: selectedRoom.name,
      room_price: selectedRoom.price,
    };

    emailjs
      .send(
        "service_kmkcgs3",
        "template_c3asdce",
        templateParams,
        "RbnxvBNkLv2JZlm7o"
      )
      .then(() => {
        alert("Booking sent successfully ✅");
        setLoading(false);
        handleClose();
      })
      .catch((err) => {
        console.log(err);
        alert("Failed to send booking ❌");
        setLoading(false);
      });
  };

  return (
    <>
      <div className="availability-bar">

        <div className="availability-form" data-aos="zoom-in">

          <div className="check-availability">
            <div className="check-icon">✓</div>
            <h2 className="check-av">CHECK AVAILABILITY</h2>
          </div>

          <div className="input-box">
            <label>Arrival Date</label>
            <input
              type="date"
              name="arrival"
              min={today}
              value={formData.arrival}
              onChange={handleChange}
            />
          </div>

          <div className="input-box">
            <label>Departure Date</label>
            <input
              type="date"
              name="departure"
              min={formData.arrival || today}
              value={formData.departure}
              onChange={handleChange}
            />
          </div>

          <div className="input-box">
            <label>Adults</label>

            <div className="d-flex align-items-center gap-2 mt-2">
              <button className="btn btn-success" onClick={() => decreaseCount("adults")}>-</button>
              <div className="px-3 fw-bold">{formData.adults}</div>
              <button className="btn btn-success" onClick={() => increaseCount("adults")}>+</button>
            </div>
          </div>

          <div className="input-box">
            <label>Children</label>

            <div className="d-flex align-items-center gap-2 mt-2">
              <button className="btn btn-success" onClick={() => decreaseCountchildren("children")}>-</button>
              <div className="px-3 fw-bold">{formData.children}</div>
              <button className="btn btn-success" onClick={() => increaseCount("children")}>+</button>
            </div>
          </div>

          <button className="check-btn" onClick={handleCheck}>
            FIND THE BEST RATE
          </button>

        </div>
      </div>

      {/* STEP 1 MODAL → ROOMS */}
      <Modal show={show} onHide={handleClose} centered size="lg">

        <Modal.Header closeButton>
          <Modal.Title>Select Room</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <div className="row">

            {rooms.map((room, i) => (
              <div className="col-md-6 mb-3" key={i}>
                <div
                  className="card p-3 shadow-sm"
                  onClick={() => setSelectedRoom(room)}
                  style={{
                    cursor: "pointer",
                    border: selectedRoom?.name === room.name ? "2px solid green" : ""
                  }}
                >
                  <h5 className="text-success">{room.name}</h5>
                  <p className="fw-bold">{room.price}</p>

                  {selectedRoom?.name === room.name && (
                    <span className="badge bg-success">Selected</span>
                  )}
                </div>
              </div>
            ))}

          </div>

        </Modal.Body>

        <Modal.Footer>

          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>

          <Button variant="outline-success" onClick={handleRoomsPage}>
            Check Rooms
          </Button>

          <Button variant="success" onClick={handleNext}>
            Book Now
          </Button>

        </Modal.Footer>

      </Modal>

      {/* STEP 2 MODAL → USER INFO */}
      <Modal show={showUserModal} onHide={handleClose} centered>

        <Modal.Header closeButton>
          <Modal.Title>Enter Your Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <input
            type="text"
            name="name"
            placeholder="Full Name"
            className="form-control mb-2"
            value={userData.name}
            onChange={handleUserChange}
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            className="form-control mb-2"
            value={userData.email}
            onChange={handleUserChange}
          />

          <p className="mt-3">
            <strong>Room:</strong> {selectedRoom?.name}
          </p>

        </Modal.Body>

        <Modal.Footer>

          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>

          <Button
            variant="success"
            onClick={handleBooking}
            disabled={loading}
          >
            {loading ? "Sending..." : "Confirm Booking"}
          </Button>

        </Modal.Footer>

      </Modal>
    </>
  );
};

export default AvailabilityBar;